import logoImage from '../assets/images/logo/awael-masr-logo.png';

export const BRAND_NAME = 'أوائل مصر';
export const BRAND_FULL_NAME = 'منصة أوائل مصر';
export const BRAND_TAGLINE = 'تعليم أونلاين';

/** @deprecated Kept for compatibility — use BRAND_NAME / BRAND_FULL_NAME */
export const BRAND_TEACHER_NAME = BRAND_NAME;
/** @deprecated Kept for compatibility — use BRAND_FULL_NAME */
export const BRAND_TEACHER_PLATFORM = BRAND_FULL_NAME;

/** Names used in SEO / schema.org alternateName */
export const BRAND_ALTERNATE_NAMES = [
  BRAND_NAME,
  BRAND_FULL_NAME,
  'تعليم أونلاين',
  'منصة تعليمية',
  'Awael Masr',
  'Awael Masr Platform',
] as const;

/** Front-1 style: Brand - Tagline (exact phrases Google should match) */
export const BRAND_TITLE =
  `${BRAND_FULL_NAME} | ${BRAND_NAME} — منصة تعليم أونلاين لكل المراحل وكل المواد`;

/** ~150 chars — ideal meta description length for SERP snippets */
export const BRAND_DESCRIPTION =
  'منصة أوائل مصر: كورسات أونلاين لكل المراحل الدراسية وكل المواد — ابتدائي وإعدادي وثانوي، عربي ورياضيات وعلوم وإنجليزي وأكثر. سجّل وابدأ التعلم الآن.';

/** Clamp SEO title toward ~50–60 characters without cutting mid-word harshly */
export const clampSeoTitle = (title: string, max = 60): string => {
  const t = title.trim();
  if (t.length <= max) return t;
  return `${t.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
};

/** Clamp meta description toward ~140–160 characters */
export const clampSeoDescription = (description: string, max = 158): string => {
  const d = description.trim();
  if (d.length <= max) return d;
  return `${d.slice(0, Math.max(0, max - 1)).trimEnd()}…`;
};

/** Core searchable phrases for Google */
export const BRAND_KEYWORDS = [
  'أوائل مصر',
  'منصة أوائل مصر',
  'تعليم أونلاين',
  'منصة تعليمية',
  'كورسات أونلاين',
  'كل المراحل الدراسية',
  'ابتدائي',
  'إعدادي',
  'ثانوي',
  'كل المواد',
  'رياضيات',
  'علوم',
  'لغة عربية',
  'لغة إنجليزية',
  'دروس أونلاين',
].join(', ');

export const BRAND_THEME_COLOR = '#001848';
export const BRAND_ACCENT_COLOR = '#C09048';

/** Logo-matched palette — cream home / hero system */
export const THEME = {
  navy: '#001848',
  navyDeep: '#001230',
  navySoft: '#0C2448',
  gold: '#C09048',
  goldLight: '#CC9C54',
  goldDark: '#A87824',
  ink: '#001230',
  muted: '#5A6B82',
  cream: '#F5F1E8',
  creamSoft: '#FAF7F0',
  creamDeep: '#EFE8DC',
  creamBorder: '#E5DCCF',
  paper: '#FFFEF8',
  surface: '#F5F1E8',
} as const;

export const SITE_URL = 'https://awaelmasr.com';
export const CONTACT_EMAIL = 'info@awaelmasr.com';
export const CONTACT_WHATSAPP = '201023483013';
export const CONTACT_WHATSAPP_URL = `https://wa.me/${CONTACT_WHATSAPP}`;
/** Technical support — Telegram (same Egyptian number) */
export const CONTACT_TELEGRAM = '201023483013';
export const CONTACT_TELEGRAM_URL = `https://t.me/+${CONTACT_TELEGRAM}`;
export const CONTACT_FACEBOOK_URL = '';
export const CONTACT_YOUTUBE_URL = '';

export const GRADE_SEO: Record<
  string,
  { title: string; short: string; keywords: string }
> = {
  secondary1: {
    title: 'الصف الأول الثانوي',
    short: 'أولى ثانوي',
    keywords: 'الصف الأول الثانوي, أولى ثانوي, مناهج أولى ثانوي',
  },
  secondary2: {
    title: 'الصف الثاني الثانوي',
    short: 'تانية ثانوي',
    keywords: 'الصف الثاني الثانوي, تانية ثانوي, مناهج تانية ثانوي',
  },
  secondary3: {
    title: 'الصف الثالث الثانوي',
    short: 'تالتة ثانوي',
    keywords: 'الصف الثالث الثانوي, تالتة ثانوي, مراجعات ثانوية عامة',
  },
};

export { logoImage };
